import CompensationFeeCards from "components/CompensationFeeCards";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { CompensationFeeCardsAdapterProps } from ".";

const CompensationFeeCardsAdapter = ({
  blok: { cards = [] },
}: ReactStoryblokComponent<CompensationFeeCardsAdapterProps>) => <CompensationFeeCards cards={cards} />;

export default CompensationFeeCardsAdapter;
